import React, {useEffect, useState} from 'react';
import JobBasicContent from "@pages/job/edit/JobBasicContent";
import JobCategoryContent from "@pages/job/edit/JobCategoryContent";
import JobRequirementContent from "@pages/job/edit/JobRequirementContent";
import JobOtherContent from "@pages/job/edit/JobOtherContent";
import {cloneDeep} from "lodash";
import {Modal} from "react-bootstrap";
import Button from "react-bootstrap/Button";
import {CandidateDetailLanguageMode} from "@app/constants/Tabs";
import SearchJobBasicContent from "@pages/job/list/advancesearch/SearchJobBasicContent";
import SearchJobCategoryContent from "@pages/job/list/advancesearch/SearchJobCategoryContent";
import SearchJobRequireContent from "@pages/job/list/advancesearch/SearchJobRequireContent";
import SearchJobForAdContent from "@pages/job/list/advancesearch/SearchJobForAdContent";
import {LOCAL_STORAGE_USER_LOGIN_INFO} from "@app/constants/Common";

const InitSearchConditions = {
    'employer_name': '',
    'job_title': '',
    'industry': '',
    'function': '',
    'job_level': '',
    'local_province': '',
    'local_area': '',
    'job_status': '',
}

const AdvanceSearchJobModal = (props) => {
    const [searchConditions, setSearchConditions] = useState(cloneDeep(InitSearchConditions));
    const [searching, setSearching] = useState(false);
    const [userLoginInfo, setUserLoginInfo] = useState({});

    const {isShow, advanceSearchInput, onClose, onSearch} = props

    const onChangeSearchConditions = (changes) => {
        if (changes) {
            setSearchConditions({...searchConditions, ...changes})
        }
    }

    useEffect(() => {
        if (!userLoginInfo.id && localStorage.getItem(LOCAL_STORAGE_USER_LOGIN_INFO)) {
            setUserLoginInfo(JSON.parse(localStorage.getItem(LOCAL_STORAGE_USER_LOGIN_INFO)))
        }
    }, [])

    useEffect(() => {
        setSearchConditions(advanceSearchInput)
    }, [advanceSearchInput])

    const onClearSearchCondition = () => {
        const fields = Object.keys(searchConditions)
        fields.forEach(f => {
            searchConditions[f] = ''
        })
        setSearchConditions({...searchConditions})
    }

    return (
        <>
            <Modal show={isShow}
                   size={'lg'}
                   onHide={() => onClose()}
                   animation={false}>
                <Modal.Header>
                    <Modal.Title>Tìm kiếm job</Modal.Title>
                    <Button variant='secondary' onClick={() => onClose()}>
                        Close
                    </Button>
                </Modal.Header>
                <Modal.Body>
                    <ul className='nav nav-tabs' role='tablist'>
                        <li className='nav-item'>
                            <a className='nav-link active' data-toggle='tab' href='#search-category-tab'>Phân loại</a>
                        </li>
                        <li className='nav-item'>
                            <a className='nav-link' data-toggle='tab' href='#search-basic-tab'>TT cơ bản</a>
                        </li>
                        <li className='nav-item'>
                            <a className='nav-link' data-toggle='tab' href='#search-requirement-tab'>Yêu cầu</a>
                        </li>
                        {userLoginInfo.is_superuser &&
                        <li className='nav-item'>
                            <a className='nav-link' data-toggle='tab' href='#search-for-ad-tab'>For Ad</a>
                        </li>
                        }
                    </ul>
                    <div className='tab-content'>
                        <div id='search-category-tab' className='tab-pane active'>
                            <SearchJobCategoryContent advanceSearchInput={searchConditions} onChange={(searchInput) => {
                                onChangeSearchConditions(searchInput)
                            }}/>
                        </div>
                        <div id='search-basic-tab' className='tab-pane'>
                            <SearchJobBasicContent advanceSearchInput={searchConditions} onChange={(searchInput) => {
                                onChangeSearchConditions(searchInput)
                            }}/>
                        </div>
                        <div id='search-requirement-tab' className='tab-pane'>
                            <SearchJobRequireContent advanceSearchInput={searchConditions} onChange={(searchInput) => {
                                onChangeSearchConditions(searchInput)
                            }}/>
                        </div>
                        {userLoginInfo.is_superuser &&
                        <div id='search-for-ad-tab' className='tab-pane'>
                            <SearchJobForAdContent advanceSearchInput={searchConditions} onChange={(searchInput) => {
                                onChangeSearchConditions(searchInput)
                            }}/>
                        </div>
                        }
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <button
                        type='submit'
                        className='btn btn-default'
                        onClick={() => onClearSearchCondition()}
                        disabled={searching}
                    >
                        {'Clear'}
                    </button>
                    <button
                        type='button'
                        className='btn btn-primary'
                        onClick={() => onSearch(searchConditions)}
                        disabled={searching}
                    >
                        {searching ? 'Searching' : 'Search'}
                    </button>
                </Modal.Footer>
            </Modal>
        </>
    )
}

export default AdvanceSearchJobModal;
